import type { IconSvgObject } from './types';

const Tree05Icon: IconSvgObject = [
  ["path", { d: "M12 22V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 17.4836C16.6764 16.7687 18 15.2035 18 12.0195C18 7.60125 15 2.01953 12 2.01953C9 2.01953 6 7.60125 6 12.0195C6 15.2035 7.32362 16.7687 9 17.4836", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 15L14.5 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 13L9.5 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M10 22H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Tree05Icon;
